// NCERTBooksLanding.jsx
// Single-file React component for a landing page. Uses Tailwind CSS for styling.
// Replace placeholder links and images with your real assets before deploying.

import React from "react";

export default function NCERTBooksLanding() {
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.myapp.ncertbooks"; // replace
  const apkUrl = "https://od.lk/d/NDJfNTAxMDA2MzFf/ncert-Books.apk"; // replace
  const supportEmail = "techidea090@gmail.com"; // replace

  return (
    <>
      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div className="min-h-screen bg-gradient-to-b from-[#0D1B2A] to-white text-gray-900">
      {/* Header / Hero */}
      <header className="mx-[5%] py-12">
        <nav className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* Logo placeholder - replace src with your logo file */}
            <div className="w-12 h-12  flex items-center justify-center">
              <img src="/assets/logo.png" alt="NCERT Books" className="w-10 h-10 object-contain" />
            </div>
            <span className="text-white text-2xl font-semibold">NCERT Books</span>
          </div>

          <div className="flex items-center gap-3">
            <a href={apkUrl} className="hidden sm:inline-block bg-white text-[#0D1B2A] px-4 py-2 rounded-lg font-medium">Download</a>
            <a href="#features" className="text-white/80 hover:text-white">Features</a>
            <a href="#screenshots" className="text-white/80 hover:text-white">Screenshots</a>
            <a href={`mailto:${supportEmail}`} className="text-white/80 hover:text-white">Contact</a>
          </div>
        </nav>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="text-white">
            <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">NCERT Books App - Free Download Class 1 to 12 CBSE Textbooks & Solutions</h1>
            <p className="mt-4 text-white/80 max-w-xl">Download free NCERT books app with PDF for all classes 1-12. Get CBSE textbooks, NCERT solutions, and study materials offline. Perfect app for board exams, UPSC, SSC preparation with bookmarks and notes.</p>

            <div id="download" className="mt-8 flex gap-4 flex-wrap">
              {/* <a href={playStoreUrl} target="_blank" rel="noreferrer" className="bg-[#fff] text-[#0D1B2A] px-5 py-3 rounded-lg font-semibold shadow hover:scale-[1.01] transition">📱 Get on Play Store</a> */}

              <a href={apkUrl} className="bg-[#0D1B2A] border border-white/10 text-white px-5 py-3 rounded-lg font-semibold hover:bg-white/5 transition">📱 Download App</a>

              <a href={`mailto:${supportEmail}`} className="ml-2 text-sm text-white/80 underline">Need help?</a>
            </div>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2 text-white/80">
              <li>📱 App with all NCERT books Class 1-12</li>
              <li>📖 NCERT solutions included in app</li>
              <li>🔄 Offline app - No internet needed</li>
              <li>🔖 App bookmarks & personal notes</li>
              <li>⚡ Fast PDF reader app with search</li>
              <li>🆓 100% Free app - No cost ever</li>
            </ul>
          </div>

          {/* Tablet mockup */}
          <div className="flex justify-center">
            <div className=" md:w-[620px]  ">
              <img src="/assets/tablet-mock.webp" alt="App mock" className="w-full h-auto rounded-lg" />
            </div>
          </div>
        </div>
      </header>

      {/* Screenshots */}
      <section id="screenshots" className="py-12">
        <h2 className="text-2xl font-bold text-[#0D1B2A] mb-6 ml-[5%]">📚 NCERT Books App Screenshots - See How It Works</h2>
        <div className="overflow-x-auto hide-scrollbar" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          <div className="flex gap-4 pb-4 pr-[100px] pl-[5%] justify-center" style={{ width: 'max-content' }}>
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="bg-white rounded-3xl overflow-hidden shadow-lg p-3 flex items-center justify-center flex-shrink-0"
              >
                {/* Phone mockup frame */}
                <div className="w-[260px] aspect-[9/19] bg-black rounded-[2rem] shadow-xl border-[6px] border-black overflow-hidden flex items-center justify-center">
                  <img
                    src={`/assets/screenshot-${i + 1}.JPEG`}
                    alt={`Screenshot ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="bg-white/70 py-12">
        <div className="mx-[5%]">
          <h2 className="text-2xl font-bold text-[#0D1B2A] mb-6">🎆 Why 10,000+ Students Love Our NCERT Books App</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">📱 Complete Offline App</h3>
              <p className="mt-2 text-sm text-gray-600">Download NCERT books app once and read anywhere without internet. Perfect mobile app for students in areas with poor connectivity.</p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">⚡ Smart PDF Reader</h3>
              <p className="mt-2 text-sm text-gray-600">Fast loading PDF viewer with chapter-wise index. Jump to any topic instantly and navigate like a pro.</p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">📚 Study Tools</h3>
              <p className="mt-2 text-sm text-gray-600">Add bookmarks to important pages, create personal notes, and organize your study material efficiently.</p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">🎯 Exam Ready</h3>
              <p className="mt-2 text-sm text-gray-600">Perfect for CBSE board exams, UPSC, SSC, Banking and other competitive exams that require NCERT knowledge.</p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">🆓 Completely Free NCERT Books App</h3>
              <p className="mt-2 text-sm text-gray-600">Download our NCERT books app for free. No subscription, no ads, no hidden charges. All classes and subjects included in the app.</p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">📖 All Subjects in One App</h3>
              <p className="mt-2 text-sm text-gray-600">Mathematics, Science, English, Hindi, Social Science and all CBSE curriculum subjects available in our single mobile app.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Student Testimonials */}
      <section className="bg-gray-50 py-12">
        <div className="mx-[5%]">
          <h2 className="text-2xl font-bold text-[#0D1B2A] mb-8 text-center">🎆 What Students Say About Our NCERT Books App</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg shadow">
              <p className="text-sm text-gray-600 italic">"Best NCERT books app for free download! All textbooks available offline in the app. The bookmark feature helps a lot in board exam preparation."</p>
              <div className="mt-4">
                <p className="font-semibold text-sm">Priya Sharma</p>
                <p className="text-xs text-gray-500">Class 12 CBSE Student</p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <p className="text-sm text-gray-600 italic">"Perfect NCERT books app for UPSC preparation! All NCERT books in one mobile app with solutions. This app saved me so much money on buying books."</p>
              <div className="mt-4">
                <p className="font-semibold text-sm">Rahul Kumar</p>
                <p className="text-xs text-gray-500">UPSC Aspirant</p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <p className="text-sm text-gray-600 italic">"Amazing NCERT books app! Clean app interface, fast loading, and completely free. Best mobile app resource for CBSE students."</p>
              <div className="mt-4">
                <p className="font-semibold text-sm">Anjali Patel</p>
                <p className="text-xs text-gray-500">Class 10 Student</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12">
        <div className="mx-[5%]">
          <h2 className="text-2xl font-bold text-[#0D1B2A] mb-8 text-center">❓ NCERT Books - Frequently Asked Questions</h2>
          <div className="max-w-3xl mx-auto space-y-6">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-semibold text-lg mb-2">Are NCERT books completely free to download?</h3>
              <p className="text-gray-600">Yes, all NCERT books are 100% free to download and use. All textbooks for Class 1-12 are available without any cost, subscription, or hidden charges.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-semibold text-lg mb-2">Can I read NCERT books offline?</h3>
              <p className="text-gray-600">Yes! Once you download the NCERT books, you can read them completely offline. No internet connection required for reading, making notes, or using bookmarks.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-semibold text-lg mb-2">Which classes and subjects are available?</h3>
              <p className="text-gray-600">Currently Class 10 books are available with Class 1-12 coming soon. All major subjects including Mathematics, Science, English, Hindi, Social Science, and other CBSE curriculum books.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-semibold text-lg mb-2">Is this app good for competitive exam preparation?</h3>
              <p className="text-gray-600">Yes! NCERT books are essential for UPSC, SSC, Banking, Railway, and other competitive exams. Our app provides easy access to all NCERT content with study tools.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-semibold text-lg mb-2">How do I download NCERT books?</h3>
              <p className="text-gray-600">Simply click the 'Download Free NCERT Books' button above to get our app. Install it and you'll have access to all NCERT textbooks and solutions instantly.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="mx-[5%] py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold">📚 Start Your Free NCERT Study Journey</h2>
          <p className="text-sm text-gray-600">Join thousands of students using our free NCERT books for better board exam and competitive exam preparation.</p>
        </div>
        <div className="flex gap-3">
          {/* <a href={playStoreUrl} target="_blank" rel="noreferrer" className="bg-[#fff] text-[#0D1B2A] px-4 py-2 rounded-md font-medium shadow">📱 Play Store</a> */}
          <a href={apkUrl} className="bg-[#0D1B2A] text-white px-4 py-2 rounded-md font-medium border border-white/10">📚 Download App</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0D1B2A] text-white py-8">
        <div className="mx-[5%] flex flex-col md:flex-row justify-between gap-6">
          <div>
            <h5 className="font-bold text-lg">NCERT Books</h5>
            <p className="text-sm text-white/80 mt-2">Free NCERT textbooks for Class 1 to 12 and More coming soon.</p>
          </div>

          <div>
            <h6 className="font-medium">Contact</h6>
            <a href={`mailto:${supportEmail}`} className="block mt-2 text-white/80">{supportEmail}</a>
            <p className="text-sm mt-2 text-white/60">© {new Date().getFullYear()} NCERT Books</p>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
}
